import { render, staticRenderFns } from "./fontWeightPick.vue?vue&type=template&id=6d6edcc2&scoped=true&"
import script from "./fontWeightPick.vue?vue&type=script&lang=js&"
export * from "./fontWeightPick.vue?vue&type=script&lang=js&"
import style0 from "./fontWeightPick.vue?vue&type=style&index=0&id=6d6edcc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6edcc2",
  null
  
)

export default component.exports